module.exports = __webpack_public_path__ + "images/emoji/dog2.65d7cdd80fc02a0ddac4.png";